// ─── Image refs ───────────────────────────────────────────────────────────────
const IMG_PPT     = "https://static.prod-images.emergentagent.com/jobs/41ef69e5-e4fb-4fd7-8f79-f334d2b03553/images/4644f1f033372a424e75c6933df65dbc8a71a9bb52edaaa1323afcab660a80d8.png";
const IMG_3D      = "https://static.prod-images.emergentagent.com/jobs/41ef69e5-e4fb-4fd7-8f79-f334d2b03553/images/c405163be7cd45258c2ce74186e94458b8f81d246427cf04a115c5286a9ef0f0.png";
const IMG_MOTION  = "https://static.prod-images.emergentagent.com/jobs/41ef69e5-e4fb-4fd7-8f79-f334d2b03553/images/7ae434af281f3447814f2a2e4b1df4bb588f9112646f2bbf6d046ef2e83652c5.png";
const IMG_TMPL    = "https://images.unsplash.com/photo-1623887318350-b604bd5fb4b1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85";
const IMG_WEB     = "https://images.unsplash.com/photo-1742669966755-fb673576f7fa?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85";
const IMG_CODE    = "https://images.unsplash.com/photo-1760548425425-e42e77fa38f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85";
const IMG_MEDICAL = "https://images.unsplash.com/photo-1576086213369-97a306d36557?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85";
const IMG_AVATAR  = "https://images.pexels.com/photos/8107821/pexels-photo-8107821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_VEDIT   = "https://images.unsplash.com/photo-1574717025058-2f8737d2e2b7?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85";
const IMG_ADS     = "https://images.unsplash.com/photo-1769750216011-28855a9aad37?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85";

// ─── All active services ───────────────────────────────────────────────────────
export const SERVICES = [
  // ── Creative & Design ──────────────────────────────────────────────────────
  {
    id: "ppt",
    category: "Creative & Design",
    name: "Custom Presentations",
    short: "PPTs that pitch & close",
    description:
      "Investor decks, sales pitches, and keynote-grade slides — designed pixel by pixel to make your story unforgettable.",
    image: IMG_PPT,
    deliverables: ["Investor decks", "Sales pitches", "Keynote design", "Editable masters"],
  },
  {
    id: "3d",
    category: "Creative & Design",
    name: "3D Models",
    short: "Cinematic 3D assets",
    description:
      "Hero models, product viz, and abstract shapes — engineered for the web, ready for AR/VR, optimized to render fast.",
    image: IMG_3D,
    deliverables: ["Product 3D", "Web GLB/GLTF", "Renders", "AR-ready files"],
  },
  {
    id: "templates",
    category: "Creative & Design",
    name: "Premium Templates",
    short: "Plug-and-play kits",
    description:
      "Battle-tested templates for landing pages, decks, and brand systems — drop in your content and launch the same day.",
    image: IMG_TMPL,
    deliverables: ["Landing kits", "Deck templates", "Brand kits", "Notion docs"],
  },
  {
    id: "video-edit",
    category: "Creative & Design",
    name: "Video Editing",
    short: "Cinematic post-production",
    description:
      "From raw footage to polished final cut — color grading, motion graphics, sound design, and storytelling that keeps viewers hooked.",
    image: IMG_VEDIT,
    deliverables: ["Color grading", "Motion graphics", "Sound design", "Social reels"],
  },
  {
    id: "photo-edit",
    category: "Creative & Design",
    name: "Photo Editing",
    short: "Studio-grade retouching",
    description:
      "Professional product photography editing, brand imagery, composite work, and visual identity assets — pixel-perfect every time.",
    image: IMG_PPT,
    deliverables: ["Product retouching", "Brand imagery", "Composite work", "Visual assets"],
  },

  // ── Web & Software ─────────────────────────────────────────────────────────
  {
    id: "software",
    category: "Web & Software",
    name: "Custom Software",
    short: "Tailored apps & tools",
    description:
      "From SaaS dashboards to internal tools — full-stack engineering with modern frameworks, scalable architecture, and zero technical debt.",
    image: IMG_PPT,
    deliverables: ["Web apps", "APIs", "Dashboards", "Automations"],
  },
  {
    id: "landing",
    category: "Web & Software",
    name: "Landing Pages",
    short: "Conversion-first pages",
    description:
      "High-velocity landing pages with smart CTAs, motion design, and analytics baked in. Built to convert from the first scroll.",
    image: IMG_PPT,
    deliverables: ["Single-page sites", "A/B variants", "Lead capture", "Analytics"],
  },
  {
    id: "website",
    category: "Web & Software",
    name: "Custom Websites",
    short: "Full marketing sites",
    description:
      "Multi-page websites with CMS, blog, and case studies. Modern stack, blazing fast, accessible, SEO-ready.",
    image: IMG_WEB,
    deliverables: ["Marketing sites", "CMS", "Blog/Case studies", "SEO setup"],
  },
  {
    id: "animated",
    category: "Web & Software",
    name: "Animated Websites",
    short: "Motion-rich experiences",
    description:
      "Scroll-triggered storytelling, WebGL hero scenes, and choreographed micro-interactions — designed to feel alive.",
    image: IMG_MOTION,
    deliverables: ["WebGL scenes", "Scroll storytelling", "Microinteractions", "Lottie integration"],
  },
  {
    id: "workflow",
    category: "Web & Software",
    name: "Workflow Automations",
    short: "n8n, Make & custom pipelines",
    description:
      "End-to-end business automation — connecting your tools, eliminating manual work, and building intelligent pipelines that run 24/7 without human intervention.",
    image: IMG_CODE,
    deliverables: ["n8n / Make flows", "API integrations", "Trigger pipelines", "CRM automation"],
  },
  {
    id: "ecosystem",
    category: "Web & Software",
    name: "Digital Ecosystems",
    short: "Platform & product ecosystems",
    description:
      "Interconnected platforms with APIs, marketplaces, and user ecosystems — designed to create network effects from day one.",
    image: IMG_WEB,
    deliverables: ["Platform architecture", "API ecosystems", "Marketplace builds", "Multi-app suites"],
  },
  {
    id: "pcb",
    category: "Web & Software",
    name: "PCB Design",
    short: "Precision circuit board design",
    description:
      "Custom PCB layouts for prototypes, IoT hardware, and production-ready boards — schematic capture, signal integrity analysis, and Gerber-ready output.",
    image: IMG_CODE,
    deliverables: ["Schematic design", "PCB layout", "Gerber files", "BOM & assembly"],
  },

  // ── AI & Intelligence ──────────────────────────────────────────────────────
  {
    id: "ai-agents",
    category: "AI & Intelligence",
    name: "AI Agents",
    short: "Custom intelligent agents",
    description:
      "Domain-specific AI agents — chat copilots, research assistants, automation bots — built on the latest LLMs, wired into your tools, deployed with guardrails.",
    image: IMG_MOTION,
    deliverables: ["Chat copilots", "Research assistants", "Automation bots", "Custom RAG / memory"],
  },
  {
    id: "ai-avatar",
    category: "AI & Intelligence",
    name: "AI Avatars",
    short: "Hyper-realistic digital humans",
    description:
      "Custom AI-powered digital avatars for content, sales, and virtual presence — lip-synced, multilingual, and ready for deployment across all platforms.",
    image: IMG_AVATAR,
    deliverables: ["Video avatars", "Real-time streaming", "Multilingual voice", "Brand characters"],
  },
  {
    id: "ai-call",
    category: "AI & Intelligence",
    name: "AI Call Agents",
    short: "Voice AI for your business",
    description:
      "Inbound and outbound AI voice agents that handle calls, qualify leads, book appointments, and answer queries — 24/7, zero burnout, zero cost per call.",
    image: IMG_MOTION,
    deliverables: ["Inbound call handling", "Lead qualification", "Appointment booking", "CRM integration"],
  },
  {
    id: "personal-ai",
    category: "AI & Intelligence",
    name: "Personal AI Agents",
    short: "Your intelligent digital assistant",
    description:
      "Private, personalized AI agents trained on your data — managing your calendar, research, communications, and decisions with full context memory.",
    image: IMG_CODE,
    deliverables: ["Custom knowledge base", "Calendar & email", "Research assistant", "Memory & context"],
  },
  {
    id: "medical-ai",
    category: "AI & Intelligence",
    name: "Medical AI Software",
    short: "AI for healthcare & biotech",
    description:
      "Domain-specific AI for medical applications — from protein structure analysis and cancer detection models to clinical decision support tools and diagnostic pipelines.",
    image: IMG_MEDICAL,
    deliverables: ["Cancer detection AI", "Protein structure tools", "Clinical ML models", "DICOM processing"],
  },

  // ── Media & Marketing ──────────────────────────────────────────────────────
  {
    id: "video",
    category: "Media & Marketing",
    name: "Custom Videos",
    short: "Cinematic motion",
    description:
      "Brand films, product walkthroughs, and animated explainers — written, designed, and rendered end-to-end for maximum impact.",
    image: IMG_MOTION,
    deliverables: ["Brand films", "Explainers", "Product reels", "Motion graphics"],
  },
  {
    id: "marketing-ads",
    category: "Media & Marketing",
    name: "Marketing & Ads",
    short: "Performance creatives",
    description:
      "High-converting ad creatives, campaign assets, and marketing collateral — designed for digital-first audiences across every platform and format.",
    image: IMG_ADS,
    deliverables: ["Ad creatives", "Campaign design", "Social assets", "A/B test variants"],
  },
];

// ─── Coming Soon services ─────────────────────────────────────────────────────
export const SERVICES_COMING_SOON = [
  {
    id: "ar-vr",
    name: "AR / VR Experiences",
    short: "Spatial computing & immersive worlds",
    description: "WebXR, Meta Quest builds, and spatial design — the next frontier of interactive product experiences.",
  },
  {
    id: "blockchain",
    name: "Blockchain & Web3",
    short: "Decentralized apps & smart contracts",
    description: "DApps, token ecosystems, NFT platforms, and on-chain automation built for the decentralized era.",
  },
  {
    id: "robotics",
    name: "Robotics Software",
    short: "Control systems & autonomous AI",
    description: "ROS-based control stacks, autonomous navigation, and vision-based perception for next-gen machines.",
  },
];

// ─── Service categories (for tab filtering) ───────────────────────────────────
export const SERVICE_CATEGORIES = [
  "All",
  "Creative & Design",
  "Web & Software",
  "AI & Intelligence",
  "Media & Marketing",
];

// ─── Featured services shown on Landing (8 hand-picked) ──────────────────────
export const FEATURED_SERVICE_IDS = [
  "ppt", "software", "3d", "animated", "ai-agents",
  "ai-avatar", "workflow", "medical-ai",
];

export const PRICING_TIERS = [
  {
    name: "Spark",
    tagline: "For quick wins",
    features: [
      "Single deliverable",
      "1 round of revisions",
      "5–7 day turnaround",
      "Source files included",
      "Email support",
    ],
    accent: "cyan",
  },
  {
    name: "Studio",
    tagline: "For serious launches",
    features: [
      "Multi-page or full asset suite",
      "3 rounds of revisions",
      "2–3 week turnaround",
      "Custom 3D / animation",
      "Priority support",
      "30-day post-launch care",
    ],
    accent: "violet",
    highlight: true,
  },
  {
    name: "Signature",
    tagline: "Bespoke at scale",
    features: [
      "End-to-end product or brand",
      "Unlimited revisions in scope",
      "Dedicated team & PM",
      "Cinematic video + WebGL",
      "SLAs & retainer options",
      "Quarterly strategy sessions",
    ],
    accent: "teal",
  },
];

export const CONTACT = {
  phone: "9902155712",
  phoneDisplay: "+91 99021 55712",
  email: "baligarvedant@gmail.com",
};

export const PORTFOLIO = [
  { id: 1, title: "Fluxon SaaS", category: "Software", img: "https://images.unsplash.com/photo-1623887318350-b604bd5fb4b1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85", span: "lg:col-span-7 lg:row-span-2" },
  { id: 2, title: "Nebula Deck", category: "Presentation", img: IMG_PPT, span: "lg:col-span-5" },
  { id: 3, title: "Helix 3D Pack", category: "3D Models", img: IMG_3D, span: "lg:col-span-5" },
  { id: 4, title: "Aurora Landing", category: "Landing Page", img: IMG_WEB, span: "lg:col-span-7" },
  { id: 5, title: "Pulse Reel", category: "Animated Video", img: IMG_MOTION, span: "lg:col-span-12" },
];

export const TESTIMONIALS = [
  { quote: "Xion turned our pitch deck into a weapon. We closed our seed round in 14 days.", name: "Aman R.", role: "Founder, Nebulalytics" },
  { quote: "The animated landing page they built for us doubled our trial-to-paid conversion.", name: "Sara K.", role: "VP Marketing, Ionix" },
  { quote: "Their 3D models were so good our investor thought we already had a product.", name: "Mateo D.", role: "CEO, Quanta Labs" },
];

export const PROCESS = [
  { step: "01", title: "Discover", body: "Tell us your goal. We dig deep into product, audience, and brand voice." },
  { step: "02", title: "Design", body: "Concepts, motion boards, and prototypes — refined until it feels inevitable." },
  { step: "03", title: "Build", body: "Engineering, 3D, animation. Pixel-precise builds with zero compromise." },
  { step: "04", title: "Launch", body: "Polish, QA, deploy. We stay on for 30 days to make sure it sings." },
];
